import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import * as bootstrap from "bootstrap";
import { Global } from "src/app/global";
import {
  DadosReceituario,
  ReceituarioItem,
} from "src/app/models/dadosReceituario";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import {
  ReceituarioFavorito,
  ReceituarioFavoritoItem,
} from "src/app/models/RecituarioFavorito";
import { Subject } from "rxjs";
import { debounceTime, switchMap } from "rxjs/operators";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ModalLaudoLmeComponent } from "src/app/modals/modal-laudo-lme/modal-laudo-lme.component";
import { LaudoLmeListComponent } from "../../laudo-lme-list/laudo-lme-list.component";

interface dadosReceituarioFavorito {
  nomeReceituarioFavorito: string;
  observacao: string;
  recomendacao: string;
  receituarioFavoritoItens: [];
}

interface Medicamento {
  principio_ativo: string;
  tipo_dose: string;
  concentracao: string;
  forma_farmaceutica: string;
  unidade_fornecimento: string;
  quantidade: any;
  posologia: string;
  id: number;
  medicamentoDescricao: string;
  posologiaDescricao: string;
  searchTextPosologia?: any;
}

interface posologia {
  ativo: boolean;
  atualizado_em: Date;
  criado_em: Date;
  descricao: string;
  id: number;
}

@Component({
  selector: "app-receituario-v2",
  templateUrl: "./receituario-v2.component.html",
  styleUrls: ["./receituario-v2.component.css"],
})
export class ReceituarioV2Component implements OnInit {
  @ViewChildren("quantidadeInput")
  quantidadeInputElements!: QueryList<ElementRef>;
  @ViewChildren("quantidadeInputFavoritos")
  quantidadeInputElementsFavoritos!: QueryList<ElementRef>;
  @ViewChild("posologiaInput", { static: false })
  posologiaInputElement: ElementRef;
  @ViewChild("posologiaInputFavorito", { static: false })
  posologiaInputElementFavorito: ElementRef;
  @ViewChild("quantidade", { static: false }) qtd: ElementRef;
  @ViewChild("inputInicial", { static: false }) inputInicial: ElementRef;
  @ViewChild("fechaModalVinculacao", { static: false })
  fechaModalVinculacao: ElementRef;
  @Input() cidadao_id: null;
  @ViewChild(LaudoLmeListComponent, { static: false }) laudoLmeList!: LaudoLmeListComponent;

  handleKeyDown(event: KeyboardEvent, input: HTMLInputElement) {
    if (event.key === "Tab") {
      event.preventDefault(); //
      this.inputInicial.nativeElement.focus();
    }
  }

  modalRef: BsModalRef;
  seeList: any = true;
  showLoading = false;
  tableHeaders = [
    "protocolo",
    "nome_profissional_emitente",
    "nome_unidade_saude",
    "receitado_em",
  ];
  inputSearch: boolean = false;
  usuario: any = {};
  global_: any;
  presenca: any;
  cliente: any;
  user: any;
  uid: any;
  searchText: string = "";
  searchTextFavorito = "";

  searchTextPosologia = "";
  medicamentos = [];
  posologia;
  itensSelecionados: Medicamento[] = [];
  descricaoSelecionada: posologia[] = [];
  buscaListaReceituarios: any = [];
  filtroMedicamento = [];
  filtroPosologia = [];
  novoMedicamento;
  novaPosologia;
  ultimoItemSelecionado;
  dadosReceituario: DadosReceituario;
  receituarioItem: ReceituarioItem;
  nomeArquivoImpressoReceituario: string = "";
  form: FormGroup;
  itemDetalhes: {
    criado_em?: string;
    protocolo?: string;
    nome_profissional_emitente?: string;
    medicamentos?: {
      medicamentoDescricao: string;
      posologiaDescricao: string;
      concetracao: string;
    };
  } = {};
  loadingFiltro: boolean = false;
  timeoutId: any;

  postPosologia: {
    descricao: string;
  };

  visualizar_prontuario: any = false;
  dadosImpresso: any;
  favoritos: ReceituarioFavorito;
  favoritoNome: string = "";
  observacoes: string = "";
  recomendacoes: string = "";
  nomeTouched: boolean = false;
  searchTerm$ = new Subject<string>();
  favo: any;
  favoList: any;
  listaReceituarioFavorito = [];
  dadosReceituarioFavorito: ReceituarioFavorito[];
  formSalvarFavorito: boolean = false;
  accordionAtivo: number | null = null;
  constructor(
    public service: ApiService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private global: Global,
    private modalService: BsModalService
  ) {
    this.global_ = global;
    this.dadosReceituario = new DadosReceituario();
    this.receituarioItem = new ReceituarioItem();
    this.authService.currentPresenca.subscribe((res) => {
      if (res) {
        this.presenca = res;
        this.dadosReceituario.unidade_saude_Id = res["estabelecimento_id"];
        this.dadosReceituario.clinica_medica_id = res["clinica_medica_id"];
        this.dadosReceituario.receitado_em = res["atualizado_em"];
        this.dadosReceituario.nome_profissional_emitente =
          res["profissional_nome"];
        this.dadosReceituario.sigla_conselho_profissional_emitente =
          res["conselho_classe_sigla"];
      }
    });

    this.authService.visualizarProntuario.subscribe((res) => {
      if (res) {
        this.visualizar_prontuario = res;
      }
    });
  }

  ngOnInit() {
    this.init();

    this.searchTerm$
      .pipe(
        debounceTime(300),
        switchMap((nome) => {
          const nomeCodificado = encodeURIComponent(nome); // Codifica o nome para URL
          return this.service.Get(
            `ReceituarioFavorito/nome-receituario?nomeReceituarioFavorito=${nomeCodificado}`
          );
        })
      )
      .subscribe(
        (res) => {
          
        },
        (err) => {
          console.error(err);
        }
      );
  }

  buscarReceituario(nome: string) {
    // Envia o termo de busca ao Subject
    this.searchTerm$.next(nome);
  }

  init = async () => {
    const uid = this.route.snapshot.paramMap.get("uuid");
    this.uid = uid;
    this.obterListaPosologia();
    this.obterListaMedicamento();
    this.getProntuarioAtendimento(uid);
    this.exame(uid);
    this.getReceituario(uid);
  };

  obterListaPosologia = () => {
    this.service.Get("Posologia").then((result) => {
      this.posologia = result;
      this.filtroPosologia = this.posologia.map((pos) => {
        return {
          ativo: pos.ativo,
          atualizado_em: pos.atualizado_em,
          criado_em: pos.criado_em,
          descricao: pos.descricao,
          id: pos.id,
        };
      });
    });
  };

  deletarPosologia(item) {
    item.posologia = "";
    item.searchTextPosologia = "";
  }

  selecionaItemPosologia(filtroPosologia, item) {
    item.searchTextPosologia = "";
    if (item) {
      item.posologia = filtroPosologia.descricao;
      this.inputInicial.nativeElement.focus();
      item.searchTextPosologia = "";
    }

    item.searchTextPosologia = "";
  }

  obterListaMedicamento = () => {
    const skip = 1; // Começar do primeiro item
    const take = 4000; // Definir um valor alto para pegar todos
    this.service.Get(`Medicamento?skip=${skip}&take=${take}`).then((result) => {
      this.medicamentos = result["conteudo"];
      this.filtroMedicamento = this.medicamentos.map((med) => {
        return {
          principio_ativo: med.principio_ativo,
          tipo_dose: med.tipo_dose,
          concentracao: med.concentracao,
          forma_farmaceutica: med.forma_farmaceutica,
          unidade_fornecimento: med.unidade_fornecimento,
          id: med.id,
        };
      });
    });
  };

  onSearchTextChange = () => {
    this.loadingFiltro = true;

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.loadingFiltro = false;
    }, 500);
  };

  setLoadingState = (loading: boolean) => {
    this.loadingFiltro = loading;
  };

  selecionaItem(filtroMedicamento) {
    if (!this.itensSelecionados) {
      this.itensSelecionados = [];
    }

    this.searchText = "";
    const jaSelecionado = this.itensSelecionados.some(
      (item) => item["id"] === filtroMedicamento["id"]
    );

    if (!jaSelecionado) {
      filtroMedicamento.quantidade = filtroMedicamento.quantidade;
      this.itensSelecionados.push(filtroMedicamento);

      setTimeout(() => {
        const inputsArray = this.quantidadeInputElements.toArray();
        
        if (inputsArray.length > 0) {
          inputsArray[inputsArray.length - 1].nativeElement.focus();
        }
      }, 0);
    }
  }

  selecionaItemFavoritos(filtroMedicamento) {
    if (!this.itensSelecionados) {
      this.itensSelecionados = [];
    }

    this.searchText = "";

    const jaSelecionado = this.itensSelecionados.some(
      (item) => item["id"] === filtroMedicamento["id"]
    );

    if (!jaSelecionado) {
      filtroMedicamento.quantidade = filtroMedicamento.quantidade;
      this.itensSelecionados.push(filtroMedicamento);

      setTimeout(() => {
        const inputsArray = this.quantidadeInputElementsFavoritos.toArray();

        if (inputsArray.length > 0) {
          inputsArray[inputsArray.length - 1].nativeElement.focus();
        }
      }, 0);
    }
  }

  preencheReceituarioItem(filtroMedicamento): ReceituarioItem {
    return {
      // id: filtroMedicamento['id'] || 0,
      criado_em: filtroMedicamento[""],
      atualizado_em: filtroMedicamento[""],
      ativo: true,
      // receituarioV2Id: 0,
      medicamentoDescricao: filtroMedicamento["principio_ativo"],
      medicamentoId: filtroMedicamento["id"],
      quantidadeDispensacao: filtroMedicamento.quantidade,
      posologiaDescricao: filtroMedicamento["posologia"] || "",
      posologiaId: filtroMedicamento["posologiaId"],
      nomeComercial: filtroMedicamento["nomeComercial"] || "",
      principioAtivo: filtroMedicamento["principio_ativo"],
      concetracao: filtroMedicamento["concentracao"],
      formaFarmaceutica: filtroMedicamento["forma_farmaceutica"],
      unidadeFornecimento: filtroMedicamento["unidade_fornecimento"],
      codigoCatMat: filtroMedicamento["codigoCatMat"] || "",
      rename: filtroMedicamento["rename"] || "",
      tipoDose: filtroMedicamento["tipo_dose"],
      observacao: filtroMedicamento["observacao"] || "",
    };
  }

  testePosologia() {
    this.itensSelecionados.forEach((item) => {
    });
  }

  salvarItens() {
    Swal.fire({
      title: "Salvando receituário",
      text: "Por favor, aguarde...",
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (this.itensSelecionados && this.itensSelecionados.length > 0) {
      this.dadosReceituario.receituario_items = [];

      this.itensSelecionados.forEach((item) => {
        if (item.searchTextPosologia && !item.posologia) {
          item.posologia = item.searchTextPosologia;
        }
        const novoItem = this.preencheReceituarioItem(item);
        this.dadosReceituario.receituario_items.push(novoItem);
      });

      this.postReceituario(this.dadosReceituario)
        .then((response) => {
          Swal.close();
          
          this.dadosReceituario.receituario_items = [];
          this.itensSelecionados = [];
          this.inputSearch = false;
          this.formSalvarFavorito = false;
          this.getReceituario(this.uid);
        })
        .catch((error) => {
          console.error("Erro ao salvar o receituário", error);
        });
    } else {
      console.log("Nenhum item selecionado para salvar.");
    }
  }

  exame(id) {
    this.service
      .Get(`Atendimento/${id}/Solicitacao?tipo_solicitacao=EXAME`)
      .then((result) => {});
  }

  postReceituario(dadosReceituario: any): Promise<any> {
    return this.service
      .Post("ReceituarioV2", dadosReceituario)
      .then((result) => {
        var postSalvo = result["nome_unidade_saude"];
        console.log("Dados Salvolvos" + postSalvo);
      });
  }

  getReceituario(id): Promise<any> {
    return this.service
      .Get(`Atendimento/${id}/ReceituarioV2`)
      .then((result) => {
        this.buscaListaReceituarios = result;
      });
  }

  deletaItemSelecionado(filtroMedicamento) {
    if (!this.itensSelecionados) {
      this.itensSelecionados = [];
    }

    this.itensSelecionados = this.itensSelecionados.filter(
      (item) => item["id"] !== filtroMedicamento["id"]
    );
  }

  adicionarNovoItem() {
    if (this.searchText.trim()) {
      this.novoMedicamento = {
        // id: new Date().getTime(),
        principio_ativo: this.searchText,
        forma_farmaceutica: "",
        concentracao: "",
        quantidade: "",
        unidade_fornecimento: "",
      };

      this.itensSelecionados.push(this.novoMedicamento);
      this.searchText = "";
      // this.inputSearch = false

      setTimeout(() => {
        const inputsArray = this.quantidadeInputElements.toArray();
        if (inputsArray.length > 0) {
          inputsArray[inputsArray.length - 1].nativeElement.focus();
        }
      }, 0);
    }
  }

  adicionarNovoItemFavorito() {
    if (this.searchText.trim()) {
      this.novoMedicamento = {
        // id: new Date().getTime(),
        principio_ativo: this.searchText,
        forma_farmaceutica: "",
        concentracao: "",
        quantidade: "",
        unidade_fornecimento: "",
      };

      this.itensSelecionados.push(this.novoMedicamento);
      this.searchText = "";
      // this.inputSearch = false

      setTimeout(() => {
        const inputsArray = this.quantidadeInputElementsFavoritos.toArray();
        if (inputsArray.length > 0) {
          inputsArray[inputsArray.length - 1].nativeElement.focus();
        }
      }, 0);
    }
  }

  adicionarNovaPosologia(item) {
    if (item.searchTextPosologia.trim()) {
      Swal.fire({
        title: "Deseja salvar a posologia?",
        text: `Descrição: ${item.searchTextPosologia.trim()}`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          const posologiaRequest = {
            descricao: item.searchTextPosologia.trim(),
          };

          item.posologia = item.searchTextPosologia.trim();
          item.searchTextPosologia = "";

          console.log(this.itensSelecionados);

          this.service.Post("Posologia", posologiaRequest).then(
            (res) => {
              console.log(res);
              Swal.fire({
                title: "Sucesso!",
                text: "Posologia salva com sucesso.",
                icon: "success",
              }).then(() => {
                this.inputInicial.nativeElement.focus();
              });

              this.obterListaPosologia();
            },
            (err) => {
              console.error("Erro ao salvar a posologia:", err);
              Swal.fire({
                title: "Erro!",
                text: "Ocorreu um erro ao salvar a posologia.",
                icon: "error",
              });
            }
          );
        }
      });
    }
  }

  adicionarQuantidade(item, novaQuantidade) {
    const itemIndex = this.itensSelecionados.findIndex((i) => i.id === item.id);
    if (itemIndex !== -1) {
      this.itensSelecionados[itemIndex].quantidade = novaQuantidade;

      setTimeout(() => {
        if (this.posologiaInputElement) {
          this.posologiaInputElement.nativeElement.focus();
        }
      }, 0);
    }
  }

  adicionarQuantidadeFavorito(item, novaQuantidade) {
    const itemIndex = this.itensSelecionados.findIndex((i) => i.id === item.id);
    if (itemIndex !== -1) {
      this.itensSelecionados[itemIndex].quantidade = novaQuantidade;

      setTimeout(() => {
        if (this.posologiaInputElementFavorito) {
          this.posologiaInputElementFavorito.nativeElement.focus();
        }
      }, 0);
    }
  }

  getProntuarioAtendimento = (id) => {
    this.service.Get(`Atendimento/${id}/Prontuario`).then((res) => {
      if (res[`length`] > 0) {
        const atendimento = res[0];
        this.dadosReceituario.atendimento_id = atendimento["atendimento_id"];
        this.dadosReceituario.presenca_id = atendimento["presenca_id"];
        this.dadosReceituario.protocolo = atendimento["protocolo"];
        this.dadosReceituario.cns_paciente =
          atendimento["atendimento_cidadao_cns"];
        this.dadosReceituario.cpf_paciente =
          atendimento["atendimento_cidadao_cpf"];
        this.dadosReceituario.nome_paciente =
          atendimento["atendimento_cidadao_nome"];
        this.dadosReceituario.nome_unidade_saude =
          atendimento["presenca_lotacao_estabelecimento_nome"];
        this.favoritoList(this.dadosReceituario.presenca_id);
      }
    });
  };

  showItem(item: any) {
    console.log(item);
    console.log("ID do item:", item);
    this.service.Get(`ReceituarioV2/id?id=${item}`).then((result) => {
      this.itemDetalhes.criado_em = result["criado_em"];
      this.itemDetalhes.protocolo = result["protocolo"];
      this.itemDetalhes.nome_profissional_emitente =
        result["nome_profissional_emitente"];
      this.itemDetalhes.medicamentos = result["receituario_items"];
      console.log(this.itemDetalhes);
      const modalElement = document.getElementById("modalShow");
      const modal = new bootstrap.Modal(modalElement!);
      modal.show();
    });
  }

  mostrarInput(event: Event): void {
    this.inputSearch = !this.inputSearch;
    this.itensSelecionados = [];
  }

  confirmationAtivarDesativar = (id: any, ativo: boolean) => {
    const actionText = ativo ? "desativar" : "ativar";
    Swal.fire({
      title: "Atenção",
      text: `Tem certeza que deseja ${actionText} esse receituário?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#dc3545",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Favor aguarde");
        Swal.showLoading();

        const novoAtivo = !ativo;
        const body = {
          id: id,
          ativo: novoAtivo,
        };

        this.service
          .Patch_body("ReceituarioV2", body)
          .then((res) => {
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Sucesso!",
              html: "Operação realizada com sucesso!",
            }).then((result) => {
              if (result.isConfirmed) {
                this.getReceituario(this.uid);
              }
            });
          })
          .catch((err) => {
            if (err.status == 401 || err.error.status == 401) {
              Swal.close();
              this.authService.logoutUser();
            }
            Swal.close();
            Swal.fire({
              icon: "error",
              title: "Erro",
              html: err.error.erros[0].messagem,
            });
          });
      }
    });
  };

  enviarWhatsApp(item: any) {
    console.log(item);
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service.Get(`ReceituarioV2/${item}/Impresso/Whatsapp`).then((res) => {
      if (res) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          html: "Operação realizada com sucesso!",
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      }
    });
  }

  imprimirDado(item: any) {
    Swal.fire({
      title: "Receituário especial?",
      text: "Deseja imprimir o receituário especial?",
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Não",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Sim",
    }).then((result) => {
      if (result.isConfirmed) {
        this.nomeArquivoImpressoReceituario =
          "RECEITUARIO_CONTROLE_ESPECIAL_V2.frx";
      } else {
        this.nomeArquivoImpressoReceituario = "RECEITUARIO_V2.frx";
      }
      this.carregarDadosImpresso(item);
    });
  }

  carregarDadosImpresso(id: any) {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .PostImpresso(
        `Documento/impresso-pdf/${this.nomeArquivoImpressoReceituario}`,
        [
          {
            nome: "id",
            valor: id.toString(),
          },
        ]
      )
      .then((res) => {
        if (res) {
          var link: any = res;
          Swal.close();
          window.open(link, "_blank");
        }
      });
  }

  preencheFavoritos(filtroMedicamento): ReceituarioFavorito {
    const receituarioFavoritoItem: ReceituarioFavoritoItem = {
      ativo: true,
      receituarioFavoritoId: 0, // Pode ser preenchido posteriormente
      medicamentoDescricao: filtroMedicamento["principio_ativo"],
      medicamentoId: filtroMedicamento["id"],
      quantidadeDispensacao: filtroMedicamento.quantidade,
      posologiaDescricao: filtroMedicamento["posologia"] || "",
      posologiaId: filtroMedicamento["posologiaId"],
      nomeComercial: filtroMedicamento["nomeComercial"] || "",
      principioAtivo: filtroMedicamento["principio_ativo"],
      concetracao: filtroMedicamento["concentracao"],
      formaFarmaceutica: filtroMedicamento["forma_farmaceutica"],
      unidadeFornecimento: filtroMedicamento["unidade_fornecimento"],
      codigoCatMat: filtroMedicamento["codigoCatMat"] || "",
      rename: filtroMedicamento["rename"] || "",
      tipoDose: filtroMedicamento["tipo_dose"],
      observacao: filtroMedicamento["observacao"] || "",
    };

    return {
      nome_receituario_favorito: "",
      presenca_id: 0,
      recomendacao: "",
      observacao: filtroMedicamento["observacao"] || "",
      receituario_favorito_itens: [receituarioFavoritoItem],
    };
  }

  fecharFavorito() {
    this.searchTextPosologia = "";
    this.searchText = "";
  }

  salvarFavorito() {
    const favoritosItens = this.itensSelecionados.map(
      (item) => this.preencheFavoritos(item).receituario_favorito_itens[0]
    );

    const payload = {
      nome_receituario_favorito: this.favoritoNome,
      presenca_id: this.dadosReceituario.presenca_id,
      recomendacao: this.recomendacoes || "",
      observacao: this.observacoes || "",
      receituario_favorito_itens: favoritosItens,
    };

    if (payload) {
      Swal.fire({
        title: "Tem certeza?",
        text: "Deseja salvar este favorito?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, salvar!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.service.Post("ReceituarioFavorito", payload).then(
            (response) => {
              Swal.fire(
                "Salvo!",
                "O favorito foi salvo com sucesso.",
                "success"
              );
              this.searchTextPosologia = "";
              this.favoritoNome = "";
              this.observacoes = "";
              this.recomendacoes = "";
              this.favoritoList(this.dadosReceituario.presenca_id);
              this.fechaModalVinculacao.nativeElement.click();
              this.inputSearch = true;
            },
            (error) => {
              Swal.fire(
                "Erro!",
                "Ocorreu um erro ao salvar o favorito.",
                "error"
              );
            }
          );
        }
      });
    }

    console.log(payload);
  }

  favoritoList(id) {
    const skip = 1; // Começar do primeiro item
    const take = 4000; // Definir um valor alto para pegar todos
    this.service
      .Get(`ReceituarioFavorito?presenca_id=${id}&skip=${skip}&take=${take}`)
      .then((res) => {
        this.favo = res["conteudo"];
        this.listaReceituarioFavorito = this.favo.map((med) => {
          return {
            nomeReceituarioFavorito: med.nomeReceituarioFavorito,
          };
        });
      });
  }

  buscaFavorito(nome) {
    return this.service.Get(`ReceituarioFavorito/${nome}`).then((res) => {
      this.favoList = res;
      console.log(this.favoList);
    });
  }

  visualizarParaListaPrincipal(favoritoItens: any) {
    favoritoItens.receituarioFavoritoItens.forEach((item: any) => {
      const novoItem: Medicamento = {
        principio_ativo: item.principioAtivo,
        tipo_dose: item.tipoDose,
        concentracao: item.concetracao,
        forma_farmaceutica: item.formaFarmaceutica,
        unidade_fornecimento: item.unidadeFornecimento,
        id: item.id,
        quantidade: item.quantidadeDispensacao,
        posologia: item.posologiaDescricao || "", // Ajustar se necessário
        medicamentoDescricao: item.medicamentoDescricao || "", // Ajustar se necessário
        posologiaDescricao: item.posologiaDescricao || "", // Ajustar se necessário
      };

      this.itensSelecionados.push(novoItem);
    });
  }

  toggleAccordion(index: number): void {
    this.accordionAtivo = this.accordionAtivo === index ? null : index;
  }

  abrirModalLaudoLme() {
    this.modalRef = this.modalService.show(ModalLaudoLmeComponent, {
      initialState: {
        atendimentoId: this.dadosReceituario.atendimento_id,
        presencaId: this.dadosReceituario.presenca_id,
        cidadaoId: this.cidadao_id,
      },
      class: "modal-xxl",
    });

    this.modalRef.content.onClose.subscribe((salvo: boolean) => {
      if (salvo) {
        this.laudoLmeList.buscarLaudosLme();
      }
    });
  }
}
